import axios from 'axios';
import {SubscribeKey} from "modules/subscribe/share-app/api/entity/SubscribeKey";
import {Subscribe} from "modules/subscribe/share-app/api/entity/Subscribe";
import {SubscribeInfo} from "modules/subscribe/share-app/api/entity/SubscribeInfo";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

interface SubscribeResult {
    status: string
}

export interface SubscribeResultRemove {
    isRemove: boolean
}

class SubscribeApi {
    async getSubscribe(key: SubscribeKey): Promise<Subscribe>  {
        const response = await axios.post('/subscribe/channels', {subscribeKey: key});

        return Subscribe.createByObj(response.data);
    }

    async removeSubscribe(subscribeId: String): Promise<any> {
        const response = await axios.delete('/subscribe/remove/' + subscribeId);

        return response.data as SubscribeResultRemove;
    }

    async subscribe(subscribeKey: SubscribeKey, channels: Array<string>): Promise<SubscribeResult> {
        const response = await axios.post('/subscribe', {subscribeKey, channels});

        return response.data as SubscribeResult;
    }

    async getSubscribes():Promise<Array<SubscribeInfo>>  {
        const response = await axios.get('profile/subscribes');
        const list = [];
        for (const item of response.data) {
            list.push(SubscribeInfo.createByObj(item));
        }
        return list;
    }
}

const api = new SubscribeApi();

export { api };
